import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import House from "../../Assets/images/rentrental.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 430,
  bgcolor: "white",
  boxShadow: 24,
  borderRadius: "16px",
  p: 2,
  maxWidth: "95%",
  outline: "none",
};

function Summary({ open, handleClose, handleBack, handleContinue, data }) {
  const getDynamicDate = (yearsToAdd = 1) => {
    const d = new Date();
    d.setFullYear(d.getFullYear() + yearsToAdd);
    const fullMonths = [
      "JANUARY",
      "FEBRUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER",
    ];
    return `${d.getDate()} ${fullMonths[d.getMonth()]}, ${d.getFullYear()}`;
  };

  const handleContinueLocal = () => {
    if (handleContinue) {
      handleContinue();
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: { enter: 500, exit: 0 },
        }}
      >
        <Fade in={open} timeout={{ enter: 500, exit: 0 }}>
          <Box sx={style}>
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <div className="flex items-center gap-3">
                <ArrowBackIcon
                  className="text-back-color2 cursor-pointer"
                  onClick={handleBack}
                />
                <p className="font-[700] text-[18px] text-back-color2">
                  Summary
                </p>
              </div>
              <IconButton
                onClick={handleClose}
                sx={{
                  bgcolor: "#1F2937",
                  color: "white",
                  "&:hover": { bgcolor: "#374151" },
                  width: 36,
                  height: 36,
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>

            {/* Apartment Details Card */}
            <div className="border border-gray-100 rounded-2xl p-4 flex gap-4 items-center mb-6 shadow-sm">
              <img
                src={
                  data?.apartmentClassImagesDTOS?.[0]?.imageUrl ||
                  data?.apartmentImages?.[0]?.imageUrl ||
                  House
                }
                alt="apartment"
                className="w-20 h-20 rounded-xl object-cover"
              />
              <div>
                <p className="text-[15px] font-[700] text-back-color2 mb-1">
                  {data?.apartmentTitle ||
                    "5 Bed apartment in Lekki (Room 209)"}
                  {data?.bedRooms ? ` (Room ${data.bedRooms})` : ""}
                </p>
                <p className="text-[12px] text-gray-500 mb-2 flex items-center gap-1">
                  <FmdGoodOutlinedIcon sx={{ fontSize: 14 }} />{" "}
                  {data?.location || data?.locality || "Lekki • Lagos state"}
                </p>
                <p className="text-[14px] font-[700] text-[#00BC67]">
                  NGN {data?.price?.toLocaleString() || "250,000"}
                  <span className="text-gray-400 font-[400] text-[12px]">
                    /year
                  </span>
                </p>
              </div>
            </div>

            {/* Details Grid */}
            <div className="grid grid-cols-2 gap-y-8 gap-x-4 mb-10">
              <div>
                <p className="text-[12px] font-[500] text-gray-400 uppercase mb-2 tracking-wide">
                  Apartment ID
                </p>
                <p className="font-[700] text-[16px] text-back-color2">
                  #{data?.id || data?.apartmentId || "11234"}
                </p>
              </div>
              <div className="text-right">
                <p className="text-[12px] font-[500] text-gray-400 uppercase mb-2 tracking-wide">
                  Rent Tenure
                </p>
                <p className="font-[700] text-[16px] text-back-color2">
                  1 year
                </p>
              </div>

              <div>
                <p className="text-[12px] font-[500] text-gray-400 uppercase mb-2 tracking-wide">
                  Price
                </p>
                <p className="font-[700] text-[16px] text-back-color2">
                  NGN {data?.price?.toLocaleString() || "250,000"}
                </p>
              </div>
              <div className="text-right">
                <p className="text-[12px] font-[500] text-gray-400 uppercase mb-2 tracking-wide">
                  Payment Method
                </p>
                <p className="font-[700] text-[16px] text-back-color2 flex items-center justify-end gap-3">
                  Wallet
                  <span className="bg-[#F59E0B] text-white text-[12px] px-3 py-1 rounded-full cursor-pointer hover:bg-orange-600 transition-colors">
                    Change
                  </span>
                </p>
              </div>

              <div>
                <p className="text-[12px] font-[500] text-gray-400 uppercase mb-2 tracking-wide">
                  RENEWAL DATE
                </p>
                <p className="font-[700] text-[16px] text-back-color2">
                  {getDynamicDate(1)}
                </p>
              </div>
              <div className="text-right">
                <p className="text-[12px] font-[500] text-gray-400 uppercase mb-2 tracking-wide">
                  RENT EXPIRE DATE
                </p>
                <p className="font-[700] text-[16px] text-back-color2">
                  {getDynamicDate(1)}
                </p>
              </div>
            </div>

            {/* Button */}
            <button
              onClick={handleContinueLocal}
              className="w-full bg-[#00BC67] text-white font-[700] py-4 rounded-xl transition-colors text-[18px]"
            >
              Pay NGN {data?.price?.toLocaleString() || "250,000"}
            </button>

            <p className="text-center text-[12px] text-gray-400 mt-4">
              By confirming, you agree to Zouse's terms and conditions
            </p>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default Summary;
